import gql from 'graphql-tag';

export const UserPersonalizationQuery =
	// eslint-disable-next-line graphql-relay-compat/no-experimental-directives -- Read http://go/cfe-no-experimental-directives
	gql`
		query PersonalizationQuery($userId: String!) @experimental {
			experimentalUserPersonalization(userId: $userId) {
				attributes {
					name
					value
				}
			}
		}
	`;
